import { useState } from "react";
import { Award, Loader2, Send, Star } from "lucide-react";
import axios from "axios";
import { API } from "@/lib/api";

const inp = "w-full px-3 rounded-xl bg-bg border border-line text-sm focus:outline-none focus:border-[var(--q)]";
const TEXT = [["bermanfaat", "Apa yang paling bermanfaat?"], ["perbaiki", "Apa yang boleh diperbaiki?"], ["cadangan", "Cadangan program / kajian / modul seterusnya"]];
const OPT = [["nama", "Nama (pilihan)", "text"], ["telefon", "No. telefon (pilihan)", "tel"], ["email", "E-mel (pilihan)", "email"]];

export const FeedbackForm = ({ kod }) => {
  const [f, setF] = useState({ penilaian: 0, bermanfaat: "", perbaiki: "", cadangan: "", nama: "", telefon: "", email: "" });
  const [state, setState] = useState("");
  const [sijil, setSijil] = useState(true);
  const [sijilId, setSijilId] = useState(null);
  const [err, setErr] = useState("");
  const send = async () => {
    setState("busy"); setErr("");
    try { const r = await axios.post(`${API}/peserta/${kod}/maklum-balas`, f); setSijilId(sijil ? r.data.sijil_id : null); setState("done"); }
    catch (e) { setState(""); setErr(e.response?.status === 422 ? "Sila semak format no. telefon atau e-mel." : e.response?.data?.detail || "Gagal menghantar."); }
  };
  if (state === "done") return <section className="surface rounded-2xl p-6 text-center" data-testid="feedback-done"><p className="font-display text-xl text-ink">Terima kasih!</p><p className="text-sm text-mute mt-1">Maklum balas anda telah dihantar kepada trainer.</p>
    {sijilId && <a href={`${API}/peserta/${kod}/sijil/${sijilId}`} data-testid="feedback-cert-download" className="mt-4 h-11 px-6 rounded-full bg-ink text-bg text-sm font-semibold inline-flex items-center gap-2"><Award size={15} /> Muat turun Sijil</a>}</section>;
  return (
    <section className="surface rounded-2xl p-5 sm:p-6 space-y-4" data-testid="feedback-form">
      <div className="eyebrow">Maklum balas program</div>
      <div>
        <div className="text-sm text-ink mb-2">Penilaian keseluruhan</div>
        <div className="flex gap-1">
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} type="button" onClick={() => setF({ ...f, penilaian: n })} aria-label={`${n} bintang`} data-testid={`feedback-star-${n}`}
              className="h-10 w-10 grid place-items-center rounded-full hover:bg-bg"><Star size={22} className={n <= f.penilaian ? "fill-[var(--q)] text-q" : "text-mute"} /></button>
          ))}
        </div>
      </div>
      {TEXT.map(([k, l]) => (
        <label key={k} className="block"><span className="text-sm text-ink block mb-1">{l}</span>
          <textarea rows={2} maxLength={1500} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={`${inp} py-2 resize-y`} data-testid={`feedback-${k}`} /></label>
      ))}
      <div className="grid sm:grid-cols-3 gap-3">
        {OPT.map(([k, l, t]) => (
          <label key={k} className="block"><span className="text-xs text-mute block mb-1">{l}</span>
            <input type={t} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={`${inp} h-10`} data-testid={`feedback-${k}`} /></label>
        ))}
      </div>
      <label className="flex items-center gap-2 text-sm text-ink"><input type="checkbox" checked={sijil} onChange={(e) => setSijil(e.target.checked)} data-testid="feedback-want-cert" /> Saya mahu sijil penyertaan (nama wajib diisi)</label>
      {err && <p className="text-sm text-warn" role="alert" data-testid="feedback-error">{err}</p>}
      <button onClick={send} disabled={!f.penilaian || state === "busy" || (sijil && f.nama.trim().length < 2)} data-testid="feedback-submit"
        className="h-11 px-6 rounded-full bg-ink text-bg text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-40">
        {state === "busy" ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />} Hantar maklum balas
      </button>
      <p className="text-[11px] text-mute">Maklumat anda hanya dilihat oleh trainer program ini.</p>
    </section>
  );
};
